<div class="totally-fullheight-page">
  <div class="main-header samesize-row">
    <h3 class="text-center">{{ 'WaitingRoom' | translate }}</h3>
  </div>
  <div class="page">
    @if (reservations.length > 0 && reservations.length > 0) {
      <div class="header flex-column-centered white-background fullwidth margin-bottom-20 bottom-bordered">
        <h1 class="blue">{{ 'WelcomeText' | translate }}</h1>
        @if (reservations.length > 0) {
          <div style="padding: 10px 20px; font-size: larger">
            {{ 'WelcomeDescription' | translate }}
          </div>
        }
      </div>
    }
    @if (reservations.length > 0) {
      <div class="work-reservation-holder fullwidth">
        @for (reservation of reservations; track reservation.referenceId) {
          <div class="appointment-inner-box">
            <div class="flex-row-start align-items-center white-background fullheight">
              @if (reservation.plateNumber) {
                <div class="flex-column-centered align-items-center blue-background vehicle-icon-container">
                  <img
                    class="vehicle-icon"
                    src="../../../assets/images/{{ getVehicleName(reservation.vehicleType) }}_SELECTED.svg"
                  />
                </div>
              }
              <div class="flex-column-spacearound fullheight fullwidth" style="position: relative">
                <div class="flex-row-centered fullwidth time">
                  <h3>{{ reservation.startDateTime | date: 'HH:mm' }}</h3>
                </div>
                <div class="flex-row-centered fullwidth plate">
                  @if (reservation.plateNumber) {
                    <h2 class="margin-right-15 bold">
                      {{ reservation.plateNumber }}
                    </h2>
                  }
                  @if (reservation.reservationState === 1) {
                    <img src="../../../../assets/images/checkmark.png" class="checkmark" />
                  }
                </div>
                @if (reservation.reservationState < 1) {
                  <span class="bd-button-small createButton" (click)="selectedReservation = reservation">
                    {{ 'ivearrived' | translate }}
                  </span>
                }
              </div>
            </div>
          </div>
        }
      </div>
    }
    @if (reservations === null || reservations.length === 0) {
      <div class="white-background fullwidth">
        <div class="header flex-column-centered white-background fullwidth margin-bottom-20">
          <h1 class="blue">{{ 'WelcomeText' | translate }}</h1>
          @if (reservations.length === 0) {
            <div>
              {{ 'WelcomeDescriptionNoReservations' | translate }}
            </div>
          }
        </div>
        <section class="flex-row-centered fullwidth bottom-bordered white-background">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 flex-row-spacebetween">
            <div class="flex-column-spacearound">
              <img src="../../../../assets/images/bestdrive-logo.svg" class="flex-row-centered pointer-cursor" />
              @if (iconUrl !== null) {
                <a class="pointer-cursor text-center"><img src="{{ iconUrl }}" style="max-height: 100px" /></a>
              }
            </div>
            <div
              class="col-md-offset-1 col-md-4 col-xs-12 flex-column-centered black margin-bottom-20"
              style="padding: 0"
            >
              <div class="flex-column-start">
                <div class="flex-row-spacebetween fullwidth">
                  <div class="semibold"><span class="tick"></span>{{ 'Tyrechange' | translate }}</div>
                </div>
                <div class="flex-row-spacebetween fullwidth">
                  <div class="semibold"><span class="tick"></span>{{ 'Blowoutfix' | translate }}</div>
                </div>
                <div class="flex-row-spacebetween fullwidth">
                  <div class="semibold"><span class="tick"></span>{{ 'PotholeWarranty' | translate }}</div>
                </div>
                <div class="flex-row-spacebetween fullwidth">
                  <div class="semibold"><span class="tick"></span>{{ 'UndercartSetting' | translate }}</div>
                </div>
                <div class="flex-row-spacebetween fullwidth">
                  <div class="semibold"><span class="tick"></span>{{ 'ClimateCleaningFIlling' | translate }}</div>
                </div>
              </div>
            </div>
          </div>
        </section>
        @if (false) {
          <section class="flex-row-centered fullwidth padding-20-0 grey-background">
            <div class="flex-row-centered col-xs-12 col-md-12 col-lg-7" style="align-items: flex-start">
              <div class="hidden-xs col-md-4 col-sm-4 col-lg-3 flex-row-start">
                <img src="../../../../assets/images/icon_small.png" />
              </div>
              <div class="flex-column-centered flex-grow-1">
                <div class="semibold bd-blue margin-bottom-20">{{ 'Download' | translate }}</div>
                <div class="flex-row-spacearound fullwidth align-items-center">
                  <a
                    href="https://itunes.apple.com/us/app/mypoint-s/id1455197785?mt=8&ign-mpt=uo%3D2"
                    target="_blank"
                    style="opacity: 1; margin-right: 2vw"
                    ><img src="../../../../assets/images/appleAppStoreLogo.png" style="height: 60px"
                  /></a>
                  <div id="QRTag" style="margin-right: 2vw"></div>
                  <a
                    href="https://play.google.com/store/apps/details?id=hu.codevision.points"
                    target="_blank"
                    style="opacity: 1; margin-right: 2vw"
                  >
                    <img src="../../../../assets/images/enBadgeWebGeneric.png" style="height: 60px" />
                  </a>
                  <div id="QRTag2" style="margin-right: 2vw"></div>
                </div>
              </div>
            </div>
          </section>
        }
      </div>
    }
  </div>
  @if (selectedReservation !== null) {
    <div class="modal modal-visible" [@OpaIn]="selectedReservation !== null">
      <div class="modal-content">
        <button type="button" class="close" (click)="selectedReservation = null">
          <span aria-hidden="true">&times;</span>
        </button>
        <div>
          <h2>{{ 'didYouJustArrive' | translate }}</h2>
          <h3>{{ selectedReservation.plateNumber }}</h3>
          <h2>{{ 'CStation' | translate }}:</h2>
          <h3>{{ GetStation(selectedReservation) }}</h3>
        </div>
        <div class="fullwidth flex-row-end">
          <div class="bd-button-small nomargin margin-right-15" (click)="selectedReservation = null">
            {{ 'No' | translate }}
          </div>
          <div class="bd-button-small nomargin createButton" (click)="acceptReservation()">
            {{ 'Yes' | translate }}
          </div>
        </div>
      </div>
    </div>
  }

  @if (showSelfCareText) {
    <div class="modal modal-visible" [@OpaIn]="showSelfCareText">
      <div class="modal-content">
        <button type="button" class="close" (click)="showSelfCareText = false">
          <span aria-hidden="true">&times;</span>
        </button>
        <div>
          <h3>{{ selfcareText }}</h3>
        </div>
        <div class="fullwidth flex-row-end">
          <div class="bd-button-small nomargin createButton" (click)="showSelfCareText = false">
            {{ 'Okay' | translate }}
          </div>
        </div>
      </div>
    </div>
  }
</div>
